module.exports = __webpack_public_path__ + "img/moj-profil.49564780.svg";